import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSocket } from "../context/SocketContext";

export default function useChannelUnread(userId, workspaceId) {
  const { socket, isSocketReady } = useSocket();
  const client = useQueryClient();
  const key = ["account", userId, "channel-unread", workspaceId];
  const query = useQuery({
    queryKey: key,
    enabled: Boolean(userId && workspaceId && isSocketReady),
    queryFn: () => new Promise((resolve, reject) => {
      socket.timeout(15000).emit("channel:unread", {}, (error, response) => {
        if (error || !response?.ok) reject(new Error(response?.error || "Could not load unread counts"));
        else resolve(response.data?.counts || {});
      });
    }),
    refetchOnMount: "always",
  });
  useEffect(() => {
    const refresh = event => {
      if (!event || event.workspaceId === String(workspaceId)) client.invalidateQueries({ queryKey: ["account", userId, "channel-unread", workspaceId] });
    };
    socket?.on("channel:changed", refresh);
    socket?.on("channel:read", refresh);
    socket?.on("connect", refresh);
    return () => {
      socket?.off("channel:changed", refresh);
      socket?.off("channel:read", refresh);
      socket?.off("connect", refresh);
    };
  }, [socket, client, userId, workspaceId]);
  return query.data || {};
}
